/**
 * Two single-step, effect-free flows.
 *
 * `transfer` (wrapped-token send) and `claimTribunal` both finish entirely
 * on-chain; their post-confirmation work is a balance refetch and local UI
 * state. Journal coverage gives them reload-survivable pending/success state
 * and nothing more is needed.
 *
 * `TransferFunds.jsx` already guards its post-confirm block with
 * `lastHandledTransferHashRef` so the same hash is never handled twice — the
 * journal makes that guard survive a reload rather than replacing it.
 */

import { registerFlow } from "../flows";

export const TRANSFER_FLOW = "transfer";
export const TRANSFER_STEPS = { TRANSFER: "transfer" };

export const TRIBUNAL_CLAIM_FLOW = "tribunalClaim";
export const TRIBUNAL_CLAIM_STEPS = { CLAIM: "claim" };

registerFlow({ id: TRANSFER_FLOW, steps: { [TRANSFER_STEPS.TRANSFER]: {} } });
registerFlow({
  id: TRIBUNAL_CLAIM_FLOW,
  steps: { [TRIBUNAL_CLAIM_STEPS.CLAIM]: {} },
});
